import { Channel } from 'phoenix'
import { pushToChannel } from '../WebsocketConn'

export async function chatApi<T>(
  channel: Channel,
  chatAccountId: number,
  data: any
) {
  const resp = await pushToChannel<{ response: T }>(channel, 'inteliwise_api', {
    chatAccountId,
    ...data,
  })

  return resp.response
}
